import Modal from "components/ui/modal";

import useGlobalVariables from "hooks/useGlobalVariables";
import PromotionsView from "./promotionsView";
import SwipeableModal from "components/ui/swipeableModal/index.jsx";
import { useTranslation } from "react-i18next";

const PromotionModalView = ({
	isVisible,
	promotions,
	handleOnOk,
	...otherProps
}) => {
	const { isMobile } = useGlobalVariables();
	const { t } = useTranslation();

	if(isMobile) {
		return isVisible && <SwipeableModal
			title={t("common.promotions")}
			onClose={handleOnOk}
		>
			<PromotionsView {...otherProps} promotions={promotions} handleOnOk={handleOnOk} isMobile={isMobile} />
		</SwipeableModal>
	}

	return (
		<Modal
			coordinates={isMobile ? { clientX: "50vw", clientY: "50vh" } : undefined}
			isOpen={isVisible}
			onCancel={handleOnOk}
			classNames={{ content: "vs--promotions-modal", outside: "vs--promotions-modal-outside" }}
			onOutsideClick={isMobile ? handleOnOk : () => { }}
		>
			<PromotionsView {...otherProps} promotions={promotions} handleOnOk={handleOnOk} />
		</Modal>
	);
};
export default PromotionModalView;
